module.exports = __webpack_public_path__ + "img/logo_at_color.5035ead8.png";